const LangVietnamFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
    <rect width="16" height="11" fill="#DA251D" />
    <path
      d="M8 3.3 8.494 4.82 10.092 4.82 8.799 5.76 9.294 7.28 8 6.34 6.706 7.28 7.201 5.76 5.908 4.82 7.506 4.82Z"
      fill="#FFFF00"
    />
  </svg>
);

export default LangVietnamFlag;
